import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { IoClose } from 'react-icons/io5';
import ImagePlaceholder from '../ImagePlaceholder/ImagePlaceholder';
import Button from '../Button/Button';
import { formatNewsDate } from '../../../constants/newsData';
import { ROUTES } from '../../../constants/routes';
import './NewsPopup.css';

/**
 * Componente NewsPopup
 * Muestra un popup con la última noticia al cargar la página
 */
const NewsPopup = ({ news, onClose }) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Verificar si ya se mostró hoy
        const lastShown = localStorage.getItem('newsPopupLastShown');
        const today = new Date().toDateString();

        if (lastShown !== today && news) {
            // Mostrar después de 1 segundo
            const timer = setTimeout(() => {
                setIsVisible(true);
            }, 1000);

            return () => clearTimeout(timer);
        }
    }, [news]);

    const handleClose = () => {
        setIsVisible(false);
        if (onClose) onClose();
    };

    const handleDontShowToday = () => {
        const today = new Date().toDateString();
        localStorage.setItem('newsPopupLastShown', today);
        handleClose();
    };

    if (!isVisible || !news) return null;

    return (
        <div className="news-popup-overlay" onClick={handleClose}>
            <div
                className="news-popup"
                onClick={(e) => e.stopPropagation()}
            >
                <button
                    className="news-popup__close"
                    onClick={handleClose}
                    aria-label="Cerrar"
                >
                    <IoClose />
                </button>

                <div className="news-popup__badge">📰 Última Noticia</div>

                <div className="news-popup__image">
                    <ImagePlaceholder
                        src={news.image}
                        aspectRatio="16/9"
                        icon="📰"
                        alt={news.imageAlt || news.title}
                    />
                </div>

                <div className="news-popup__content">
                    <span className="news-popup__category">{news.category}</span>
                    <h3 className="news-popup__title">{news.title}</h3>
                    <p className="news-popup__date">📅 {formatNewsDate(news.date)}</p>
                    <p className="news-popup__excerpt">{news.excerpt}</p>

                    <div className="news-popup__actions">
                        <Link to={ROUTES.NEWS}>
                            <Button variant="primary" size="md" fullWidth>
                                Leer más
                            </Button>
                        </Link>
                        <button
                            className="news-popup__dont-show"
                            onClick={handleDontShowToday}
                        >
                            No mostrar hoy
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewsPopup;
